
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    // 检测是否为移动设备
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
      setIsMobile(isMobileDevice);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleBrandStoryClick = () => {
    navigate('/about');
  };

  const handleExploreClick = () => {
    // 滚动到产品展示区域
    const productSection = document.querySelector('[data-product-shop]');
    if (productSection) {
      productSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleVideoLoad = () => {
    setVideoLoaded(true);
  };

  const handleVideoError = () => {
    setVideoLoaded(false);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 移动端背景图片 */}
      {isMobile && (
        <div 
          className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/fc32fef34ec0bd62adfaf877813944d0.jfif')`
          }}
        />
      )}

      {/* 桌面端视频背景 */}
      {!isMobile && (
        <>
          <video
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            onLoadedData={handleVideoLoad}
            onError={handleVideoError}
          >
            <source src="https://public.readdy.ai/ai/video_res/919f3de3-290d-403b-be80-53863d6e96ad.mp4" type="video/mp4" />
          </video>
          
          {/* 视频加载失败时的备用背景 */}
          {!videoLoaded && (
            <div 
              className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/fc32fef34ec0bd62adfaf877813944d0.jfif')`
              }}
            />
          )}
        </>
      )}
      
      <div className="absolute inset-0 bg-gradient-to-r from-[#2f3673]/70 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
          {/* Left Content */}
          <div className="text-left space-y-6">
            <div className="space-y-3">
              <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
                <span className="block text-white">塑东方体魄</span>
                <span className="block text-[#f7931d]">养狮虎人生</span>
              </h1>
              <p className="text-base md:text-lg text-gray-200 font-medium">
                中国狮虎堂中草药集团有限公司 荣誉呈现
              </p>
            </div>
            
            <div className="space-y-4">
              <p className="text-sm text-gray-300 max-w-lg leading-relaxed">
                融汇三地精粹，唤醒沉睡在你体内的原生力量。
                以香港的国际标准，云南的道地药材，泰国的天然草本，
                为现代男性打造专属的养生之道。
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <button 
                  onClick={handleExploreClick}
                  className="bg-[#2f3673] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#1e2557] transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  探索狮虎人生
                </button>
                <button 
                  onClick={handleBrandStoryClick}
                  className="border-2 border-white text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-white hover:text-[#2f3673] transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  了解品牌故事
                </button>
              </div>
            </div>
            
            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-4 pt-6">
              <div className="flex items-center space-x-1 text-white">
                <i className="ri-shield-check-fill text-[#f7931d] text-sm"></i>
                <span className="text-xs font-medium">香港品质保证</span>
              </div>
              <div className="flex items-center space-x-1 text-white">
                <i className="ri-leaf-fill text-[#f7931d] text-sm"></i>
                <span className="text-xs font-medium">天然草本配方</span>
              </div>
              <div className="flex items-center space-x-1 text-white">
                <i className="ri-award-fill text-[#f7931d] text-sm"></i>
                <span className="text-xs font-medium">三地精粹融合</span>
              </div>
            </div>
            
          </div>
          
          {/* Right Content - Product Image */}
          <div className="hidden lg:block">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/d3cc2e6327107ba11e0887c451c8c53d.png"
                alt="狮虎堂产品"
                className="w-1/3 h-auto rounded-2xl shadow-2xl mx-auto"
              />
            </div>
          </div>
          
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
}
